<template>
  <div class="bracket-categories-page" :class="classes">
    <CitiesList
      title="Результаты"
      :get-link="getLink"
      final-link="/brackets/final"
    />
  </div>
</template>

<script>
import CitiesList from "@/components/city/CitiesList";

export default {
  name: "BracketCategoriesPage",
  components: {
    CitiesList
  },
  props: {
    iframe: Boolean
  },
  computed: {
    classes() {
      return {
        "bracket-categories-page_iframe": this.iframe
      };
    }
  },
  methods: {
    getLink(city) {
      if (!city) return;
      return {
        name: "brackets-view",
        params: { slug: city.id }
      };
    }
  }
};
</script>

<style lang="scss">
.bracket-categories-page {
  &_iframe {
    max-width: 900px;
    margin: 0 auto;
  }
}
</style>
